module.exports = __webpack_public_path__ + "static/media/congrats.34a32f6c.png";